import { Button, CloseButton, Stack, Text, Title } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";

import { useDeleteTruckMutation } from "@/store";

type DeleteTruckProps = {
  id: number;
  plate?: string;
};
export function DeleteTruck({ id, context, innerProps }: ContextModalProps<DeleteTruckProps>) {
  const [trigger, { isLoading }] = useDeleteTruckMutation();

  const handleClose = () => {
    context.closeModal(id);
  };

  const handleDelete = async () => {
    const { id } = innerProps;
    try {
      await trigger({ id });
      handleClose();
    } catch {
      // Do nothing
    }
  };

  return (
    <Stack>
      <div className="flex items-center justify-between gap-[inherit]">
        <Title order={3}>Deletar Caminhão</Title>

        <CloseButton onClick={handleClose} />
      </div>

      <Text ta="center">
        Tem certeza que deseja excluir o caminhão {innerProps.plate}? <br /> Esta ação não pode ser desfeita.
      </Text>

      <div className="grid grid-cols-1 gap-[inherit] md:grid-cols-2">
        <Button variant="default" onClick={handleClose} disabled={isLoading}>
          Cancelar
        </Button>

        <Button color="red" onClick={handleDelete} loading={isLoading}>
          Excluir Caminhão
        </Button>
      </div>
    </Stack>
  );
}
